export function on(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/socket.io-client/build/esm/on.js
// module id = 726
// module chunks = 0